import { useEffect, useState } from 'react'

/**
 * React hook for debouncing values with a serializable snapshot
 * This prevents object reference changes from causing unnecessary updates
 */
export function useDebouncedSnapshot<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(() =>
    // Create initial serializable snapshot
    JSON.parse(JSON.stringify(value)),
  )

  useEffect(() => {
    const handler = setTimeout(() => {
      // Create a serializable snapshot to break object references
      const snapshot = JSON.parse(JSON.stringify(value))
      setDebouncedValue(snapshot)
    }, delay)

    return () => {
      clearTimeout(handler)
    }
  }, [value, delay])

  return debouncedValue
}
